import { FiItemsListFilterHelperService } from './../fi-items-list/fi-items-list-filter/fi-items-list-filter-helper.service';
import { INameIdObj } from './../fi-shared-interfaces';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { DateRange } from '@angular/material/datepicker';
import { MatMenuTrigger } from '@angular/material/menu';
import { IPeriodDateRange } from './fi-time-range-menu';
import { AppTextService } from '../app-text';
import { FiInfoIconMode } from '../info-icon/info-icon.component';

@Component({
    selector: 'fi-time-range-menu',
    templateUrl: './fi-time-range-menu.component.html',
    styleUrls: ['./fi-time-range-menu.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-time-range-menu' },
    standalone: false,
})
export class FiTimeRangeMenuComponent implements OnInit {
    @Input({ required: true }) periodDateRange: IPeriodDateRange<any>;
    @Output() periodDateRangeChange = new EventEmitter<IPeriodDateRange<any>>();

    @Input() timeIntervalOptions: INameIdObj[];
    @Input() isMenuLayout: boolean;
    @Input() customDateRangeValue: number;
    @Input() tooltipText: string;
    @Input() tooltipClass: string;
    @ViewChild(MatMenuTrigger) trigger: MatMenuTrigger;

    protected dateRange: DateRange<Date>;
    protected readonly FiInfoIconMode = FiInfoIconMode;
    constructor(
        private itemsListFilterHelperService: FiItemsListFilterHelperService,
        private appTextService: AppTextService,
    ) {}

    public ngOnInit() {
        this.setDateRange();
    }

    get dateTooltipClass(): string {
        return (
            this.tooltipClass +
            ' fi-icon-text-content-tooltip fi-rounded-white-tooltip history-chart-widget-card-heading-tooltip no-arrow'
        );
    }

    private setDateRange() {
        this.dateRange = new DateRange<Date>(this.periodDateRange.StartDate, this.periodDateRange.EndDate);
    }

    protected getCurrentHistoryWidgetIntervalLabel(): string | undefined {
        if (this.isDateRangeSelected(this.customDateRangeValue)) {
            return this.getDateRangeLabelInterval();
        }

        return this.timeIntervalOptionLabel();
    }

    private timeIntervalOptionLabel(): string | undefined {
        return this.timeIntervalOptions.find((interval: INameIdObj) => {
            return interval.Id === this.periodDateRange.TimePeriodType;
        })?.Name;
    }

    protected isDateRangeSelected(periodType: number): boolean {
        return this.periodDateRange.TimePeriodType === periodType;
    }

    private getDateRangeLabelInterval(): string {
        return this.itemsListFilterHelperService.getCustomDateFilterLabel(
            this.periodDateRange.StartDate,
            this.periodDateRange.EndDate,
        );
    }

    protected setHistoryWidgetTimeInterval(timePeriodType: number): void {
        if (this.isTimePeriodChanged(timePeriodType)) {
            return;
        }

        if (!this.isCustomTimePeriod(timePeriodType)) {
            this.periodDateRange.EndDate = null;
            this.periodDateRange.StartDate = null;
            this.setDateRange();
        }

        this.periodDateRange.TimePeriodType = timePeriodType;
        this.periodDateRangeChange.emit(this.periodDateRange);
    }

    protected onDateRangeChange(newDateRange: DateRange<Date>): void {
        this.periodDateRange.StartDate = newDateRange.start;
        this.periodDateRange.EndDate = newDateRange.end;
        this.setHistoryWidgetTimeInterval(this.customDateRangeValue);
        this.trigger.closeMenu();
    }

    private isTimePeriodChanged(timePeriodType: number): boolean {
        return this.isDateRangeSelected(timePeriodType) && !this.isCustomTimePeriod(timePeriodType);
    }

    private isCustomTimePeriod(timePeriodType: number): boolean {
        return timePeriodType === this.customDateRangeValue;
    }

    protected getCustomRangeLabel(): string {
        return this.isCustomTimePeriod(this.periodDateRange.TimePeriodType)
            ? this.getDateRangeLabelInterval()
            : this.appTextService.get('filter.change_custom_range');
    }
}
